import React from "react";
import {getAdvancementColor} from "../../utils/utils";
import styled from "styled-components";
import {Field} from "formik";

const InputAdvancementFormik = ({advancementSelection}) => {


    const trackAnim = {
        transform: `translateX(${advancementSelection}%`
    };

    return (

        <Advancement className={"advancement-input"}>
            <p> {`${advancementSelection} %`} </p>
            <ContainerTrack className={"flex-row"}>
                <Track style={ {background: `${getAdvancementColor(advancementSelection)}`}} >
                    <Field
                        id="input-advancement"
                        name="advancement"
                        min={0}
                        max={100}
                        step={5}
                        value={advancementSelection}
                        type="range"/>
                    <div style={trackAnim} className="animate-track"/>
                </Track>
            </ContainerTrack>
            <p> Cliquez ou faites glisser la barre pour définir l'avancement </p>
        </Advancement>
    )
}
const Advancement = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

const ContainerTrack = styled.div`
  width: 100%;
  justify-content: center;
  align-items: center;

  p {
    text-align: center;
    padding: 0 2em;
  }

  @media (min-width: 500px) {
    width: 100%;
  }

  + p {
    margin-bottom: 0.5em;

  }
`

const Track = styled.div`
  width: 70%;
  height: 0.7em;
  position: relative;
  border-radius: 1rem;
  overflow: hidden;
  margin-bottom: 1em;

  #input-advancement {
    width: 100%;
    -webkit-appearance: none;
    background: transparent;
    cursor: pointer;
  }

  .animate-track {
    background: rgb(204, 204, 204);
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    transform: translateX(0%);
    pointer-events: none;
  }

  input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    height: 16px;
    width: 16px;
    border-radius: 50%;
  }

  input[type="range"]::-moz-range-thumb {
    -webkit-appearance: none;
    background: transparent;
    border: none;
  }
  input[type="range"]:focus {
    outline: none;
    outline: #52D783;
  }
`
export default InputAdvancementFormik;